const jQ = jQuery.noConflict();

class Alignment {
    constructor({section, element, number, responsive = false, resWidth = 0, resNumber = 1 }) {
        this.section = section;
        this.element = element;
        this.number = number;
        this.responsive = responsive;
        this.resWidth = resWidth;
        this.resNumber = resNumber;
    }
    init() {
        if (jQ(this.section).length > 0) {
            jQ(this.element).evenColumns(
                {
                    columns: this.number,
                },
                {
                    maxScreenWidth: 991,
                    columns: 2,
                },
                {
                    maxScreenWidth: 767,
                    columns: 1,
                },
            );
        }
        if (jQ(this.section).length > 0 && this.responsive) {
            jQ(this.element).evenColumns(
                {
                    columns: 1,
                },
                {
                    maxScreenWidth: this.resWidth,
                    columns: this.resNumber,
                }, {
                    maxScreenWidth: 767,
                    columns: 1,
                },
            );
        }
    }
}


export default Alignment;
